<template>
  <v-container class="pa-0">
    <v-container class="wrapper pa-3">
      <v-container class="d-flex justify-start pa-0 gap-2">
        <v-btn color="primary" outlined @click="openPanelDialog('add')">
          <span>{{ $t("add-new-panel") }}</span>
          <v-icon size="16" class="mr-1">mdi-plus</v-icon>
        </v-btn>
      </v-container>
      <v-container class="pa-0 mt-5 columns">
        <v-container
          class="pa-4 column-panel d-flex justify-space-between align-center mt-2"
          v-for="(item, index) in items"
          :key="index"
        >
          <div class="d-flex align-center gap-3">
            <v-card-text class="pa-0 text-caption">{{ index + 1 }}</v-card-text>
            <v-card-text class="pa-0 text-body-2">
              {{ item.name != null ? item.name : $t("processing-panel") }}
            </v-card-text>
          </div>
          <div class="d-flex align-center gap-5">
            <v-card-text
              class="pa-0 text-body-2"
              :style="{ color: item.status == 'active' ? '#137333' : '#ff5252' }"
            >
              {{ $t(item.status) }}
            </v-card-text>
            <v-btn
              outlined
              color="primary"
              height="32"
              @click="openSyncPermission(item, index)"
              :disabled="syncingPanels.includes(index)"
            >
              {{
                syncingPanels.includes(index)
                  ? $t("synchronizing-products") + "..."
                  : $t("synchronize-products")
              }}
            </v-btn>
            <v-btn
              color="primary"
              outlined
              height="32"
              v-clipboard:copy="
                `https://integrator.abriron.com/api/basalam/order/webhook?token=${item.panel_token}`
              "
              @click="copied"
              :disabled="item.status != 'active' || item.panel_token == null"
            >
              {{ $t("orderWebhook") }}
            </v-btn>
            <!-- <v-btn
              outlined
              color="primary"
              height="32"
              :disabled="item.status != 'active'"
              @click="syncOrders(item)"
            >
            {{ $t('Synchronizing-orders') }}
            </v-btn> -->
            <div @click="openPanelDialog('edit', item)">
              <my-icon
                :name="'edit-icon'"
                :width="16"
                :height="17"
                :stroke="'#000'"
                :cursor-pointer="true"
              />
            </div>
          </div>
        </v-container>
        <v-container class="d-flex justify-space-between pa-0 mt-10">
          <v-btn color="primary" height="32" @click="submit" :loading="loading">
            {{ $t("submit") }}
          </v-btn>
          <v-btn color="secondary" height="32" outlined>
            {{ $t("cancel") }}
          </v-btn>
        </v-container>
      </v-container>
    </v-container>
    <v-dialog
      v-model="panelDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="800"
    >
      <v-card class="pa-5">
        <v-form ref="form" v-model="valid">
          <v-container class="pa-0 d-flex justify-space-between align-center">
            <v-card-text class="pa-0 text-body-1">
              {{
                dialogType == "add"
                  ? $t("add-new-panel")
                  : $t("edit-panel") +
                    " " +
                    (selectedEditItem && selectedEditItem.name
                      ? selectedEditItem.name
                      : "")
              }}
            </v-card-text>
            <v-icon size="20" @click="panelDialog = false">mdi-close</v-icon>
          </v-container>
          <v-card-text class="pa-0 text-body-2 mt-7 mb-4">{{
            $t("general-setting")
          }}</v-card-text>
          <v-container class="pa-0 d-flex gap-2">
            <v-container class="wrapper-toggle d-flex pa-0 ma-0" style="width: 151px">
              <div
                v-for="(item, index) in activatorOptions"
                :key="index"
                @click="selectStatusPanel(item)"
                class="child flex-fill text-center"
                :style="{
                  'background-color': selectedStatusPanel == item.value ? '#E5FEED' : '',
                  'border-color':
                    selectedStatusPanel == item.value ? '#0066ff' : 'silver',
                  color: selectedStatusPanel == item.value ? '#137333' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
          </v-container>
          <v-container class="pa-0 d-flex align-center gap-2 mt-5 mb-9">
            <v-text-field
              v-model="newPanel.name"
              :label="$t('panel-title')"
              outlined
              height="32"
              dense
              :rules="[(v) => !!v || $t('is-required')]"
            />
            <autocomplete
              v-model="newPanel.seller_warehouse"
              :rules="[(v) => !!v || $t('is-required')]"
              :title="$t('Choosing a warehouse with the seller')"
              type="entrepot"
            />
          </v-container>
          <v-container class="pa-0 d-flex align-center gap-2 mt-5 mb-9">
            <v-text-field
              v-model="newPanel.phone"
              :label="$t('basalam-mobile-panel')"
              outlined
              height="32"
              dense
              :rules="[(v) => !!v || $t('is-required')]"
            />
            <v-text-field
              v-model="newPanel.currency_coefficient"
              :label="$t('currency_coefficient')"
              outlined
              height="32"
              dense
              :rules="[(v) => !!v || $t('is-required')]"
              type="number"
            />
          </v-container>
          <v-container class="pa-0 d-flex align-center gap-2 mt-4 mb-9">
            <v-text-field
              v-model="newPanel.access_token"
              :label="$t('access_token')"
              outlined
              height="32"
              dense
              :rules="[(v) => !!v || $t('is-required')]"
            />
            <v-text-field
              v-model="newPanel.refresh_token"
              :label="$t('refresh_token')"
              outlined
              height="32"
              dense
              :rules="[(v) => !!v || $t('is-required')]"
            />
          </v-container>
          <v-card-text class="pa-0 text-body-2 mt-5 mb-2">{{
            $t("return-invoices")
          }}</v-card-text>
          <v-container class="d-flex gap-3 pa-0">
            <v-card-text class="pa-0 text-body-2 mt-2">{{
              $t("Select the desired option to register returned invoices")
            }}</v-card-text>
            <v-container
              class="wrapper-toggle d-flex align-center pa-0 ma-0"
              style="width: 200px"
            >
              <div
                v-for="(item, index) in activatorOptions"
                :key="index"
                @click="selectInvoiceOption(item)"
                class="child flex-fill text-center"
                :style="{
                  'background-color':
                    selectedInvoiceOption == item.value ? '#D9EEFF' : '',
                  'border-color':
                    selectedInvoiceOption == item.value ? '#0066ff' : 'silver',
                  color: selectedInvoiceOption == item.value ? '#0066FF' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
          </v-container>
          <v-card-text class="pa-0 text-body-2 mt-5 mb-2">{{
            $t("entrepotToUse")
          }}</v-card-text>
          <v-container class="d-flex align-center gap-3 pa-0 mb-7">
            <v-card-text class="pa-0 text-body-2">{{
              $t("inventory-update")
            }}</v-card-text>
            <v-container
              class="wrapper-toggle d-flex align-center pa-0 ma-0"
              style="width: 150px"
            >
              <div
                v-for="(item, index) in activatorOptions"
                :key="index"
                @click="selectStatusInventoryUpdate(item)"
                class="child flex-fill text-center"
                :style="{
                  'background-color':
                    selectedStatusInventoryUpdate == item.value ? '#E5FEED' : '',
                  'border-color':
                    selectedStatusInventoryUpdate == item.value ? '#0066ff' : 'silver',
                  color: selectedStatusInventoryUpdate == item.value ? '#137333' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
            <v-card-text class="pa-0 text-body-2">{{
              $t("fixed-price-update")
            }}</v-card-text>
            <v-container
              class="wrapper-toggle d-flex align-center pa-0 ma-0"
              style="width: 150px"
            >
              <div
                v-for="(item, index) in activatorOptions"
                :key="index"
                @click="selectStatusPriceUpdate(item)"
                class="child flex-fill text-center"
                :style="{
                  'background-color':
                    selectedStatusPriceUpdate == item.value ? '#E5FEED' : '',
                  'border-color':
                    selectedStatusPriceUpdate == item.value ? '#0066ff' : 'silver',
                  color: selectedStatusPriceUpdate == item.value ? '#137333' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
          </v-container>

          <v-container class="pa-0 d-flex align-center justify-space-between mt-10">
            <div class="d-flex align-center gap-1">
              <v-btn
                color="primary"
                height="32"
                @click="checkValidation"
                :loading="loading"
              >
                {{ dialogType == "add" ? $t("confirm") : $t("edit") }}
              </v-btn>
              <v-btn color="secondary" outlined height="32" @click="panelDialog = false">
                {{ $t("cancel") }}
              </v-btn>
            </div>
            <v-btn color="error" outlined height="32" @click="openDeletePanel">
              <span class="ml-1">{{ $t("delete-panel") }}</span>
              <my-icon
                :name="'trash-icon'"
                :width="15"
                :height="15"
                :cursor-pointer="true"
                :fill="'#ff5252'"
              />
            </v-btn>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-card-text class="pa-0 text-body-2">
          {{ $t("Are you sure you want to delete this item ?") }}
        </v-card-text>
        <v-container class="pa-0 d-flex align-center gap-2 mt-6">
          <v-btn color="error" height="32" @click="deletePanel" :loading="loading">
            {{ $t("yes") }}
          </v-btn>
          <v-btn color="secondary" height="32" outlined @click="deleteDialog = false">
            {{ $t("no") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="productSyncPermission"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-2">{{
            $t("receive product information from basalam")
          }}</v-card-text>
          <v-icon size="20" @click="productSyncPermission = false">mdi-close</v-icon>
        </v-container>
        <v-card-text class="pa-0 text-body-2 my-8" style="line-height: 25px">
          {{ $t("do you want to sync the panel product information ?") }}
          <br />
          {{ panelName }}
          <br />
          {{ $t("are you sure ?") }}
        </v-card-text>
        <v-container class="pa-0 d-flex gap-2">
          <v-btn color="primary" height="32" @click="synchronization">
            {{ $t("yes, synchronize") }}
          </v-btn>
          <v-btn
            color="secondary"
            outlined
            height="32"
            @click="productSyncPermission = false"
          >
            {{ $t("cancel") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="productSync"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-2">{{
            $t("receive product information from digikala")
          }}</v-card-text>
          <v-icon size="20" @click="productSync = false">mdi-close</v-icon>
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center my-5">
          <img src="@/assets/integrators/sync-basalam.png" />
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center">
          <v-card-text class="pa-0 text-body-2 text-center" style="line-height: 25px">
            {{ $t("we are syncing panel product information") }}
            {{ panelName }}
            {{ $t("from digikala") }}
            {{ $t("this process may take time. Please be patient.") }}
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="syncSuccessDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-2">{{
            $t("receive product information from digikala")
          }}</v-card-text>
          <v-icon size="20" @click="syncSuccessDialog = false">mdi-close</v-icon>
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center my-7">
          <img v-if="isUserGaveAccess" src="@/assets/integrators/sync-success.png" />
          <img v-else src="@/assets/integrators/sync-failed.png" />
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center">
          <v-card-text class="pa-0 text-body-2">
            {{
              isUserGaveAccess
                ? $t("your connection has been established successfully.")
                : $t(
                    "unfortunately your connection has not been established successfully."
                  )
            }}
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : ''"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import MyIcon from "../../components/general/icon/MyIcon.vue";

export default {
  data() {
    return {
      panelDialog: false,
      selectedStatusPanel: null,
      selectedInvoiceOption: null,
      selectedStatusInventoryUpdate: null,
      selectedStatusPriceUpdate: null,
      snakbar: false,
      snakbarText: null,
      snakbarColor: null,
      dialogType: null,
      valid: true,
      selectedIndex: null,
      deleteDialog: false,
      items: [],
      userInfo: null,
      loading: false,
      newPanel: {
        seller_warehouse: null,
        access_token: null,
        refresh_token: null,
        name: null,
        status: null,
        phone: null,
        currency_coefficient: null,
        return_invoices_status: null,
        inventory_update: null,
        price_update: null,
      },
      productSyncPermission: false,
      panelName: null,
      productSync: null,
      selectedSyncPanel: null,
      syncingPanels: [],
      syncSuccessDialog: false,
      isUserGaveAccess: false,
      wantedSyncPanel: null,
      panelId: null,
      selectedEditItem: null,
      syncOrderResult: null,
    };
  },
  methods: {
    fetchPanelList() {
      var app = this;
      app.$axios
        .get(this.$endpoint + "basalam/get-config")
        .then((r) => {
          this.items = r.data;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
    },
    openPanelDialog(type, selectedItem) {
      this.panelDialog = true;
      if (type == "add") {
        this.newPanel.currency_coefficient = 1;
        // consider toggle buttons default (show)
        this.selectedStatusPanel = "active";
        this.selectedInvoiceOption = "active";
        this.selectedStatusInventoryUpdate = "active";
        this.selectedStatusPriceUpdate = "active";
        // insert defaults in objects
        this.newPanel.status = this.selectedStatusPanel;
        this.newPanel.return_invoices_status = this.selectedInvoiceOption;
        this.newPanel.inventory_update = this.selectedStatusInventoryUpdate;
        this.newPanel.price_update = this.selectedStatusPriceUpdate;

        this.dialogType = "add";
      }
      if (type == "edit" && selectedItem) {
        this.dialogType = "edit";
        this.newPanel = {
          id: selectedItem.id,
          type: "basalam",
          phone: selectedItem.phone,
          abr_name: this.userInfo?.init?.abrName,
          abr_token: this.userInfo?.token,
          name: selectedItem.name,
          status: selectedItem.status,
          currency_coefficient: selectedItem.additional_data
            ? selectedItem.additional_data.currency_coefficient
            : selectedItem.currency_coefficient,
          return_invoices_status: selectedItem.additional_data
            ? selectedItem.additional_data.return_invoices_status
            : selectedItem.return_invoices_status,
          inventory_update: selectedItem.additional_data
            ? selectedItem.additional_data.inventory_update
            : selectedItem.inventory_update,
          price_update: selectedItem.additional_data
            ? selectedItem.additional_data.price_update
            : selectedItem.price_update,
          seller_warehouse: selectedItem.additional_data
            ? selectedItem.additional_data.seller_warehouse
            : selectedItem.seller_warehouse,
          access_token: selectedItem.additional_data
            ? selectedItem.additional_data.access_token
            : selectedItem.access_token,
          refresh_token: selectedItem.additional_data
            ? selectedItem.additional_data.refresh_token
            : selectedItem.refresh_token,
        };
        this.selectedStatusPanel = selectedItem.status;
        this.selectedInvoiceOption = selectedItem.additional_data
          ? selectedItem.additional_data.return_invoices_status
          : selectedItem.return_invoices_status;
        this.selectedStatusInventoryUpdate = selectedItem.additional_data
          ? selectedItem.additional_data.inventory_update
          : selectedItem.inventory_update;
        this.selectedStatusPriceUpdate = selectedItem.additional_data
          ? selectedItem.additional_data.price_update
          : selectedItem.price_update;

        this.selectedEditItem = selectedItem;
        this.selectedIndex = this.items.findIndex(
          (item) => item.name == selectedItem.name && item.status == selectedItem.status
        );
      }
    },
    selectStatusPanel(item) {
      this.selectedStatusPanel = item.value;
      this.newPanel.status = this.selectedStatusPanel;
    },
    selectInvoiceOption(item) {
      this.selectedInvoiceOption = item.value;
      this.newPanel.return_invoices_status = this.selectedInvoiceOption;
    },
    selectStatusInventoryUpdate(item) {
      this.selectedStatusInventoryUpdate = item.value;
      this.newPanel.inventory_update = this.selectedStatusInventoryUpdate;
    },
    selectStatusPriceUpdate(item) {
      this.selectedStatusPriceUpdate = item.value;
      this.newPanel.price_update = this.selectedStatusPriceUpdate;
    },
    checkValidation() {
      if (this.$refs.form.validate() && this.dialogType == "add") {
        this.submitSinglePanel();
      }
      if (this.$refs.form.validate() && this.dialogType == "edit") {
        this.editPanel();
      }
    },
    submitSinglePanel() {
      this.loading = true;
      var app = this;
      app.$axios
        .post(app.$endpoint + "basalam/store-config", [app.newPanel])
        .then((r) => {
          app.snakbarText = app.$t(r.data.message);
          app.snakbarColor = "green";
          app.snakbar = true;

          app.panelDialog = false;
          app.addPanel();
          app.fetchPanelList();
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    addPanel() {
      this.items.push(this.newPanel);
      this.panelDialog = false;
    },
    editPanel() {
      this.items.splice(this.selectedIndex, 1, this.newPanel);
      this.panelDialog = false;
    },
    openDeletePanel() {
      if (this.dialogType == "add") {
        this.panelDialog = false;
      }
      if (this.dialogType == "edit") {
        this.deleteDialog = true;
      }
    },
    submit() {
      // post api
      this.loading = true;
      var app = this;
      app.$axios
        .post(app.$endpoint + "basalam/store-config", app.items)
        .then((r) => {
          app.loading = false;
          app.snakbarText = app.$t(r.data.message);
          app.snakbarColor = "green";
          app.snakbar = true;
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    deletePanel() {
      // delete api
      this.loading = true;
      const id = this.items[this.selectedIndex].id;
      if (id != null) {
        var app = this;
        app.$axios
          .delete(this.$apipoint + `config/destroy/${id}`)
          .then((r) => {
            if (r.data.status == "success") {
              this.loading = false;
              this.items.splice(this.selectedIndex, 1);
              this.deleteDialog = false;
              this.panelDialog = false;
              this.snakbarText = this.$t("your panel removed successfully");
              this.snakbarColor = "green";
              this.snakbar = true;
            }
          })
          .catch((err) => {
            this.serverErrorHandeler(err);
          });
      } else {
        this.loading = false;
        this.items.splice(this.selectedIndex, 1);
        this.panelDialog = false;
        this.deleteDialog = false;
        this.snakbarText = this.$t("your panel removed successfully");
        this.snakbarColor = "red";
        this.snakbar = true;
      }
    },
    openSyncPermission(item, index) {
      this.productSyncPermission = true;
      this.panelName = item.name;
      this.selectedSyncPanel = index;
      this.wantedSyncPanel = item.panel_token;
    },
    synchronization() {
      var app = this;
      app.$axios
        .post("https://integrator.abriron.com/api/basalam/pulling-product", {
          panel_token: app.wantedSyncPanel,
        })
        .then((r) => {
          console.log(r.data);
          app.productSyncPermission = false;
          app.snakbar = true;
          app.snakbarText = app.$t(r.data.message);
          app.snakbarColor = "green";
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        });
    },
    // visitLink(value) {
    //   const url = `https://seller.digikala.com/pwa/seller-services/consents?client_code=WPdl2XpBf7oabmVoOlVI&redirect_url=https://integrator.abriron.com/api/digikala/auth/callback&scopes=order%20variant%20profile%20product%20inventory%20insight%20growth_coach%20question%20package%20shipment%20sbs_setting%20sbs_orders%20sbs_shipment&state=${value}`
    //   const features = 'width=800,height=600,top=100,left=200,resizable=yes,scrollbars=yes'
    //   const digikalaWindow = window.open(url, '_blank', features)

    //   const app = this
    //   let callCount = 0
    //   const maxAttempts = 200

    //   const fetchAuthStatus = () => {
    //     callCount++

    //     app.$axios.post('https://integrator.abriron.com/api/config/check-auth', {
    //       panel_token: value
    //     })
    //       .then(r => {
    //         if (r.data.message) {
    //           digikalaWindow.close()
    //           clearInterval(authInterval)
    //           clearInterval(checkWindowClosed)

    //           this.panelDialog = false
    //           this.addPanel()
    //           this.syncSuccessDialog = true
    //           this.isUserGaveAccess = true
    //         } else if (callCount >= maxAttempts) {
    //           digikalaWindow.close()
    //           clearInterval(authInterval)
    //           clearInterval(checkWindowClosed)

    //           this.panelDialog = false
    //           this.syncSuccessDialog = true
    //           this.isUserGaveAccess = false

    //           var app = this
    //           app.$axios.delete(this.$apipoint + `config/destroy/${this.panelId}`)
    //           .then(r => {
    //           })
    //           .catch(err => {
    //             this.serverErrorHandeler(err)
    //           })
    //         } else {
    //         }
    //       })
    //       .catch(err => {
    //         app.serverErrorHandeler(err)
    //       })
    //   }

    //   const authInterval = setInterval(fetchAuthStatus, 3000)
    //   fetchAuthStatus()

    //   const checkWindowClosed = setInterval(() => {
    //     if (digikalaWindow.closed) {
    //       clearInterval(authInterval)
    //       clearInterval(checkWindowClosed)
    //     }
    //   }, 1000)
    // },
    syncOrders(item) {
      // var app = this
      // app.$axios.post('https://integrator.abriron.com/api/' + 'digikala/resend-order', {
      //   token: item.panel_token
      // })
      //   .then(r => {
      //     app.snakbar = true
      //     app.snakbarText = this.$t(r.data.message)
      //     app.snakbarColor = 'red'
      //   })
      //   .catch(err => {
      //     this.serverErrorHandeler(err)
      //   })
    },
  },
  mounted() {
    this.fetchPanelList();
    this.userInfo = JSON.parse(localStorage.getItem("token"));
  },
  computed: {
    activatorOptions() {
      return [
        { label: this.$t("active"), value: "active" },
        { label: this.$t("deactive"), value: "deactive" },
      ];
    },
  },
  watch: {
    panelDialog(val) {
      if (!val) {
        // reset keys
        this.newPanel = {
          id: null,
          type: "basalam",
          phone: null,
          abr_name: this.userInfo?.init?.abrName,
          abr_token: this.userInfo?.token,
          name: null,
          status: null,
          additional_data: {
            currency_coefficient: null,
            return_invoices_status: null,
            inventory_update: null,
            price_update: null,
            seller_warehouse: null,
            access_token: null,
            refresh_token: null,
          },
        };
        // reset form
        this.$refs.form.reset();
        // reset toggle button
        this.selectedStatusPanel = null;
        this.selectedInvoiceOption = null;
        this.selectedStatusInventoryUpdate = null;
        this.selectedStatusPriceUpdate = null;

        this.newPanel.status = null;
        this.newPanel.additional_data.currency_coefficient = null;
        this.newPanel.additional_data.return_invoices_status = null;
        this.newPanel.additional_data.inventory_update = null;
        this.newPanel.additional_data.seller_warehouse = null;
        this.newPanel.additional_data.price_update = null;
        this.newPanel.additional_data.access_token = null;
        this.newPanel.additional_data.refresh_token = null;
      }
    },
    userInfo: {
      handler(val) {
        if (val?.init) {
          this.newPanel.abr_name = val.init.abrName || null;
          this.newPanel.abr_token = val.token || null;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    MyIcon,
  },
};
</script>

<style scoped>
.wrapper {
  background-color: #fcfcfc;
}
.wrapper .columns .column-panel {
  border: 1px solid silver;
  border-radius: 4px;
}
.v-card__text {
  width: auto;
}
.wrapper-toggle {
  border: 1px solid silver;
  border-radius: 4px;
}
.wrapper-toggle .child {
  padding: 7.7px;
  cursor: pointer;
  border-radius: 4px;
}
.wrapper-toggle .child:first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.wrapper-toggle .child:nth-child(2) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
</style>
